import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import { logger } from '@/services/logger';
import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

const _findByEntryId = async function findByEntryId<T>(
    lang: LocaleProps,
    contentType: ContentTypeProps,
    entryId: string,
    enableLivePreview?: boolean,
): Promise<T> {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        return (await stackClient.stack
            .ContentType(contentType)
            .Entry(entryId)
            .toJSON()
            .language(lang)
            .fetch()) as T;
    } catch (err) {
        logger.error(err);
        throw new Error(
            `An error occurred in _findByEntryId for ${entryId}: ${JSON.stringify(err)}`,
        );
    }
};

const cached_findByEntryId = unstable_cache(
    _findByEntryId,
    ['search_findByEntryId'],
    {
        revalidate: 1800,
    },
);

export const findByEntryId = async function findByEntryId<T>(
    lang: LocaleProps,
    contentType: ContentTypeProps,
    entryId: string,
    enableLivePreview?: boolean,
): Promise<T> {
    const fn =
        typeof window === 'undefined' ? cached_findByEntryId : _findByEntryId;

    return fn(lang, contentType, entryId, enableLivePreview);
};
